import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadLeistungsVerzeichnisListStatus: 'idle',
    loadLeistungsVerzeichnisListError: undefined as any,
    loadLeistungsVerzeichnisListLastArgs: undefined as any,
    loadLeistungsVerzeichnisStatus: 'idle',
    loadLeistungsVerzeichnisError: undefined as any,
    saveLeistungsVerzeichnisStatus: 'idle',
    saveLeistungsVerzeichnisError: undefined as any,
    deleteLeistungsVerzeichnisStatus: 'idle',
    deleteLeistungsVerzeichnisError: undefined as any,

    leistungsVerzeichnisList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadLeistungsVerzeichnisList = createAsyncThunk('leistungsVerzeichnisSlice/loadLeistungsVerzeichnisList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().leistungsVerzeichnisSlice.loadLeistungsVerzeichnisListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurislieistverz/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadLeistungsVerzeichnisListStatus } = getState().leistungsVerzeichnisSlice
        return loadLeistungsVerzeichnisListStatus !== 'pending'
    }
})

export const loadLeistungsVerzeichnis = createAsyncThunk('leistungsVerzeichnisSlice/loadLeistungsVerzeichnis', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurislieistverz/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadLeistungsVerzeichnisStatus } = getState().leistungsVerzeichnisSlice
        return loadLeistungsVerzeichnisStatus !== 'pending'
    }
})

export const saveLeistungsVerzeichnis = createAsyncThunk('leistungsVerzeichnisSlice/saveLeistungsVerzeichnis', async ({ leistungsVerzeichnis }: any, { rejectWithValue }: any) => {
    let promises = []
    if (leistungsVerzeichnis?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nurislieistverz/${ leistungsVerzeichnis?.HDR_ID }/`,
            prepareData(leistungsVerzeichnis),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nurislieistverz/`,
            prepareData(leistungsVerzeichnis),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveLeistungsVerzeichnisStatus } = getState().leistungsVerzeichnisSlice
        return saveLeistungsVerzeichnisStatus !== 'pending'
    }
})

export const deleteLeistungsVerzeichnis = createAsyncThunk('leistungsVerzeichnisSlice/deleteLeistungsVerzeichnis', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nurislieistverz/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteLeistungsVerzeichnisStatus } = getState().leistungsVerzeichnisSlice
        return deleteLeistungsVerzeichnisStatus !== 'pending'
    }
})

const LeistungsVerzeichnisSlice = createSlice({
    name: 'leistungsVerzeichnisSlice',
    initialState,
    reducers: {
        resetloadLeistungsVerzeichnisListError: (state) => {
            state.loadLeistungsVerzeichnisListError = undefined
        },
        resetloadLeistungsVerzeichnis: (state) => {
            state.formItem = undefined
            state.loadLeistungsVerzeichnisError = undefined
        },
        resetloadLeistungsVerzeichnisError: (state) => {
            state.loadLeistungsVerzeichnisError = undefined
        },
        resetsaveLeistungsVerzeichnis: (state) => {
            state.formItem = undefined
            state.saveLeistungsVerzeichnisError = undefined
        },
        resetsaveLeistungsVerzeichnisError: (state) => {
            state.saveLeistungsVerzeichnisError = undefined
        },
        resetdeleteLeistungsVerzeichnisError: (state) => {
            state.deleteLeistungsVerzeichnisError = undefined
        },
        removeFromLeistungsVerzeichnisListById: (state, action) => {
            state.leistungsVerzeichnisList = state.leistungsVerzeichnisList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromLeistungsVerzeichnisListByIds: (state, action) => {
            state.leistungsVerzeichnisList = state.leistungsVerzeichnisList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.leistungsVerzeichnisList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadLeistungsVerzeichnisListStatus = 'preloaded'
            state.loadLeistungsVerzeichnisListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.leistungsVerzeichnisList = []
            state.loadLeistungsVerzeichnisListStatus = 'idle'
            state.loadLeistungsVerzeichnisListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadLeistungsVerzeichnisList.pending, (state) => {
            state.loadLeistungsVerzeichnisListStatus = 'pending'
            state.loadLeistungsVerzeichnisListError = undefined
        })
        builder.addCase(loadLeistungsVerzeichnisList.fulfilled, (state, action) => {
            state.loadLeistungsVerzeichnisListStatus = 'idle'

            if (!action.payload) { return }

            state.loadLeistungsVerzeichnisListLastArgs = action.payload.args

            {
                state.leistungsVerzeichnisList = action.payload.data

            }
        })
        builder.addCase(loadLeistungsVerzeichnisList.rejected, (state, action) => {
            state.loadLeistungsVerzeichnisListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadLeistungsVerzeichnisListError = action.error.message
            } else {
                state.loadLeistungsVerzeichnisListError = action.payload
            }
        })

        builder.addCase(loadLeistungsVerzeichnis.pending, (state) => {
            state.loadLeistungsVerzeichnisStatus = 'pending'
            state.loadLeistungsVerzeichnisError = undefined
        })
        builder.addCase(loadLeistungsVerzeichnis.fulfilled, (state, action) => {
            state.loadLeistungsVerzeichnisStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.leistungsVerzeichnisList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.leistungsVerzeichnisList.push(newItem) }
                else { state.leistungsVerzeichnisList[i] = { ...state.leistungsVerzeichnisList[i], ...newItem } }
            }
        })
        builder.addCase(loadLeistungsVerzeichnis.rejected, (state, action) => {
            state.loadLeistungsVerzeichnisStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadLeistungsVerzeichnisError = action.error.message
            } else {
                state.loadLeistungsVerzeichnisError = action.payload
            }
        })

        builder.addCase(saveLeistungsVerzeichnis.pending, (state) => {
            state.saveLeistungsVerzeichnisStatus = 'pending'
            state.saveLeistungsVerzeichnisError = undefined
        })
        builder.addCase(saveLeistungsVerzeichnis.fulfilled, (state, action) => {
            state.saveLeistungsVerzeichnisStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.leistungsVerzeichnisList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.leistungsVerzeichnisList.push(newItem) }
                else { state.leistungsVerzeichnisList[i] = { ...state.leistungsVerzeichnisList[i], ...newItem } }
            }
        })
        builder.addCase(saveLeistungsVerzeichnis.rejected, (state, action) => {
            state.saveLeistungsVerzeichnisStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveLeistungsVerzeichnisError = action.error.message
            } else {
                state.saveLeistungsVerzeichnisError = action.payload
            }
        })

        builder.addCase(deleteLeistungsVerzeichnis.pending, (state) => {
            state.deleteLeistungsVerzeichnisStatus = 'pending'
            state.deleteLeistungsVerzeichnisError = undefined
        })
        builder.addCase(deleteLeistungsVerzeichnis.fulfilled, (state, action) => {
            state.deleteLeistungsVerzeichnisStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.leistungsVerzeichnisList = state.leistungsVerzeichnisList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.leistungsVerzeichnisList = state.leistungsVerzeichnisList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteLeistungsVerzeichnis.rejected, (state, action) => {
            state.deleteLeistungsVerzeichnisStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteLeistungsVerzeichnisError = action.error.message
            } else {
                state.deleteLeistungsVerzeichnisError = action.payload
            }
        })

    }
})

export const {
    resetloadLeistungsVerzeichnisListError,
    resetloadLeistungsVerzeichnis,
    resetloadLeistungsVerzeichnisError,
    resetsaveLeistungsVerzeichnis,
    resetsaveLeistungsVerzeichnisError,
    resetdeleteLeistungsVerzeichnisError,
    removeFromLeistungsVerzeichnisListById,
    removeFromLeistungsVerzeichnisListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = LeistungsVerzeichnisSlice.actions
export default LeistungsVerzeichnisSlice.reducer
